import { connect, Dispatch } from 'react-redux';
import * as actions from '../actions';
import { CannedMessages } from '../components/CannedMessages/CannedMessages';
import { AppState, Message } from '../models';

export const mapStateToProps = ({ messageState  } : AppState) => {
  return {
    messageState,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<actions.MessageAction>) => {
  return {
    addMessage: (message: string, tags: number[]) => 
    dispatch(actions.addMessageRequest(message, tags)),
    editMessageRequest: (message: Message) => dispatch(actions.editMessageRequest(message)),
    onSearch: (text: string) => dispatch(actions.searchMessageRequest(text)),
    deleteMessageRequest: (id: number) => dispatch(actions.deleteMessageRequest(id)),
    viewMessages: () => dispatch(actions.viewMessagesRequest()),
    messagesNextPage: () => dispatch(actions.messagesNextPage()),
    messagesPrevPage: () => dispatch(actions.messagesPrevPage()),
    logout: () => dispatch(actions.logoutRequest()),
    copyMessage: (id: number) => dispatch(actions.copyMessageRequest(id)),
    cancelEditMessage: () => dispatch(actions.cancelEditMessage()),
    dismissMessageBanner: () => dispatch(actions.dismissMessageBanner()),
    showAddMessageSection: () => dispatch(actions.showAddMessageSection()),
    hideAddMessageSection: () => dispatch(actions.hideAddMessageSection()),
    showEditMessagesView: () => dispatch(actions.showEditMessagesView()),
    hideEditMessagesView: () => dispatch(actions.hideEditMessagesView()),
    sortMessageRequest: (oldIndex: number, newIndex: number, categoryName: string) => {
      if (newIndex !== oldIndex) {
        dispatch(actions.sortMessageCancelPrevRequest());
        dispatch(actions.sortMessageRequest(oldIndex, newIndex, categoryName));
      }
    },
    categorySortMessageRequest: (oldIndex: number, newIndex: number) => {
      if (newIndex !== oldIndex) {
        dispatch(actions.categorySortMessageCancelPrevRequest());
        dispatch(actions.categorySortMessageRequest(oldIndex, newIndex));
      }
    },
    categoryCollapsed: (id: number, name: string) => dispatch(actions.categoryCollapsed(id, name)),
    categoryExpand: (id: number, name: string) => dispatch(actions.categoryExpand(id, name)),
  };
};

export const mergeProps = (stateProps: Object, dispatchProps: Object, ownProps: Object) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps);
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CannedMessages);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CannedMessages.tsx